/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 cup1_low_re.glb -t -d -TRS
*/

import * as THREE from 'three'
import React, { createRef, useRef } from 'react'
import { meshBounds, useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { useFrame, useThree } from '@react-three/fiber'
import state from '../../../utils/state'

type GLTFResult = GLTF & {
  nodes: {
    Model: THREE.Mesh
  }
  materials: {
    ['material0.004']: THREE.MeshStandardMaterial
  }
}

export function Cup1Simpled(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('./models/low_re/transformed/cup1_low_re-transformed.glb') as GLTFResult

  const modelRef = createRef<any>()

  const stateThree = useThree()

  const pageLerp = useRef(state.top / stateThree.size.height)

  useFrame((s, delta) => {
    const page = (pageLerp.current = THREE.MathUtils.lerp(pageLerp.current, state.top / stateThree.size.height, delta * 6))

    if (!state.lowMode) {
      modelRef.current.visible = page > 27.7 ? (page > 31 ? false : true) : false
    }
  })

  return (
    <group {...props} dispose={null}>
      <mesh ref={modelRef} geometry={nodes.Model.geometry} material={materials['material0.004']} material-metalness={0.14} material-roughness={1} rotation={[-0.48, 0.32, -0.52]} raycast={meshBounds}/>
    </group>
  )
}

useGLTF.preload('./models/low_re/transformed/cup1_low_re-transformed.glb')
